import { render, staticRenderFns } from "./JobDetialItem.vue?vue&type=template&id=4a9dc7a2&scoped=true"
import script from "./JobDetialItem.vue?vue&type=script&lang=js"
export * from "./JobDetialItem.vue?vue&type=script&lang=js"
import style0 from "./JobDetialItem.vue?vue&type=style&index=0&id=4a9dc7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9dc7a2",
  null
  
)

export default component.exports